// Display formatting shared by the API-backed pages. Every helper renders null or
// undefined as an em dash, for figures the API doesn't have yet.
export const NO_DATA = "—";

const missing = (value) => value === null || value === undefined;

export function formatNumber(value, digits = 0) {
  return missing(value)
    ? NO_DATA
    : Number(value).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function formatUsd(value, digits = 0) {
  return missing(value) ? NO_DATA : `$${formatNumber(value, digits)}`;
}

export function formatPercent(value, digits = 1) {
  return missing(value) ? NO_DATA : `${Number(value).toFixed(digits)}%`;
}

// "+1.40%" / "-0.25%"
export function formatSignedPercent(value, digits = 2) {
  return missing(value) ? NO_DATA : `${value > 0 ? "+" : ""}${Number(value).toFixed(digits)}%`;
}

// "Oct 06, 2026"
export function formatDate(value) {
  return missing(value)
    ? NO_DATA
    : new Date(value).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
}

// "Oct 06, 14:19" (with the year when it isn't this year)
export function formatDateTime(value) {
  if (missing(value)) {
    return NO_DATA;
  }
  const date = new Date(value);
  const sameYear = date.getFullYear() === new Date().getFullYear();
  const day = date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    ...(sameYear ? {} : { year: "numeric" }),
  });
  const time = date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  return `${day}, ${time}`;
}

// "just now" / "12 min ago" / "3h ago" / "4d ago", then the date
export function formatRelative(value, now = Date.now()) {
  if (missing(value)) {
    return NO_DATA;
  }
  const minutes = Math.max(0, Math.floor((now - new Date(value).getTime()) / 60000));
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes} min ago`;
  if (minutes < 24 * 60) return `${Math.floor(minutes / 60)}h ago`;
  if (minutes < 7 * 24 * 60) return `${Math.floor(minutes / (24 * 60))}d ago`;
  return formatDate(value);
}
